// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".adjust-apps-container[data-v-28296041] {\n  padding-left: 3%;\n}\n", ""]);
// Exports
module.exports = exports;
